<template>

  <div class="columns is-centered is-vcentered">

    <div class="column is-three-fifths-desktop is-four-fifths-tablet">

      <div class="card" style="padding: 30px 30px; margin-top: 35px;" :style="{opacity: (submitInProgress ? 0.3 : 1)}">
        <div class="card-content">

        <b-field label="Main draw" style="text-align: left;">
          <b-input v-model="mainDrawName" v-focus placeholder="Main draw name" required></b-input>
        </b-field>


          <b-field label="Consolation draw" style="text-align: left; visibility: hidden; margin-bottom: -60px;">
            <b-input v-model="consolationDrawName" placeholder="Consolation draw name"></b-input>
          </b-field>

          <b-tabs v-model="activeTab" @change="tabChanged" style="margin-top: 45px;">
            <b-tab-item label="Players">
              <h3 style="font-weight: 600; font-size: 1rem; text-align: left; margin-top: 15px;">Players</h3>
              <b-table :data="event.entries" checkable :checked-rows.sync="drawEntries" v-if="event">
                <template slot-scope="props">
                  <b-table-column field="id" label="#">
                    {{ props.row.id }}
                  </b-table-column>

                  <b-table-column field="id" label="Entry">
                    <Entry :tournament="tournament" :event="event" :entry="props.row" :showMissing="true" />
                  </b-table-column>

                  <b-table-column field="id" label="Event">
                    {{ event.name }}
                  </b-table-column>

                </template>
              </b-table>
            </b-tab-item>



            <b-tab-item label="Ordering" v-if="event">

              <p style="text-align: left; font-weight: bold; color: red; margin-top: 20px; margin-bottom: 25px;" v-if="preferDifferentTeams">Generating matches for players from different teams...</p>

              <b-taglist>
                <b-tag type="is-info" v-for="(entry, index) in drawEntriesOrdering" v-if="event">
                  <b-icon pack="fas" icon="arrow-up" size="is-small" @click.native="moveEntryOrder(index, -1)" style="cursor: pointer;" /> &nbsp;
                    &nbsp; {{index+1}})&nbsp; {{ getEntry(entry) }} &nbsp; &nbsp;&nbsp;
                  <b-icon pack="fas" icon="arrow-down" size="is-small" @click.native="moveEntryOrder(index, 1)" style="cursor: pointer;" />
                </b-tag>
              </b-taglist>

            </b-tab-item>
          </b-tabs>





        <p v-if="failedSubmit" style="margin-top: 27px; text-align: left; color: red;">Please make sure you complete all fields.</p>


        <div style="text-align: right;">
          <button class="button is-default" style="margin-top: 25px; margin-bottom: -10px; margin-right: 30px;" @click="goToDraws">Close</button>
          <button class="button is-primary" style="margin-top: 25px; margin-bottom: -10px;" @click.ctrl="preferDifferentTeams = true; triggerSubmit()" @click.exact="triggerSubmit">Continue</button>
        </div>
        </div>
      </div>

    </div>

  </div>
</template>

<script>
import axios from '../request';

import Entry from "../components/Entry.vue";
import TournamentDataMixin from '../mixins/TournamentDataMixin.js';

export default {
  mixins: [ TournamentDataMixin ],

  data: function() {
    return {
      mainDrawName: '',
      consolationDrawName: '',

      drawEntries: [],
      drawEntriesOrdering: [],

      activeTab: 0,
      preferDifferentTeams: false,
      submitInProgress: false,
      failedSubmit: false
    }
  },

  computed: {
    teams: function() {
      if (this.tournament) {
        return this.tournament.teams;
      }

      return [];
    },

    event: function() {
      let selected = null;
      if (this.tournament && this.tournament.events) {
        selected = this.tournament.events.filter(event => event.id == this.eventId);
        if (selected && selected.length > 0) {
          selected = selected[0];
        } else {
          selected = null;
        }
      }

      return selected;
    },
    eventId: function() { return this.$route.params.event; },
  },

  watch: {
    tournament: {
      immediate: true,

      handler() {
        if (this.tournament && this.event) {
          let mainDraw = this.event.draws.filter(draw => draw.stage === 'main-draw');
          let consolationDraw = this.event.draws.filter(draw => draw.stage === 'consolation');

          if (!this.mainDrawName && this.tournament.defaultMainDrawName) {
            this.mainDrawName = this.tournament.defaultMainDrawName;
          }

          if (!this.consolationDrawName && this.tournament.defaultConsolationDrawName) {
            this.consolationDrawName = this.tournament.defaultConsolationDrawName;
          }

          if (mainDraw && mainDraw.length > 0) {
            this.mainDrawName = mainDraw[0].name;

            if (consolationDraw && consolationDraw.length > 0) {
              this.consolationDrawName = consolationDraw[0].name;
            }
          }


          if (this.event.entries) {
            this.drawEntries = this.event.entries.filter(entry => {
              return ((typeof (entry) !== 'object') || (!entry.missing));
            });
          }

          this.$forceUpdate();
        }
      }
    }
  },

  methods: {

    goToDraws() {
      let tournamentId = this.$route.params.id;
      let eventId = this.$route.params.event;

      this.$router.push('/tournaments/' + tournamentId + '/events/' + eventId + '/draws');
    },

    attemptToGuessRanking(entries) {

      function shuffle(array, from, to) {
        let currentIndex = to + 1;

        while (from < currentIndex){
          let randomIndex = -1;

          for (let t=0; t<3 && randomIndex < from; t++) {
            randomIndex = Math.floor(Math.random() * currentIndex);
          }

          currentIndex -= 1;

          if (currentIndex >= from && currentIndex <= to) {
            if (randomIndex >= from && randomIndex <= to) {

              let temporaryValue = array[currentIndex];
              array[currentIndex] = array[randomIndex];
              array[randomIndex] = temporaryValue;
            }
          }
        }

        return array;
      }


      function reorder(array, from, to) {
        if (to >= array.length) {
          to = array.length - 1;
        }

        if (from < to) {
          array = shuffle(array, from, to);
        }

        return array;
      }


      if (this.event && this.event.suggestedEntriesRanking && this.event.suggestedEntriesRanking.length > 0) {
        let newEntries = entries.slice();
        newEntries.sort((e1, e2) => {

          let index1 = this.event.suggestedEntriesRanking.indexOf(e1.id);
          let index2 = this.event.suggestedEntriesRanking.indexOf(e2.id);

          if (index1 == -1 && index2 >= 0) {
            return 1;
          }

          if (index1 >= 0 && index2 == -1) {
            return -1;
          }

          if (index1 == -1 && index2 == -1) {
            return (e1.id - e2.id);
          }

          return (index1 - index2);
        });


        if (newEntries.length >= 4) {
          newEntries = reorder(newEntries, 3 - 1, 4 - 1);
        }

        if (newEntries.length >= 6) {
          newEntries = reorder(newEntries, 5 - 1, 8 - 1);
        }

        if (newEntries.length >= 10) {
          newEntries = reorder(newEntries, 9 - 1, 1024 - 1);
        }

        entries = newEntries;

      } else {

        //just shuffle them
        entries = reorder(entries, 0, entries.length - 1);
      }

      return entries;
    },

    tabChanged(index) {

      if (index == 1) {
        if (this.mainDrawName && (this.consolationDrawName || this.drawEntries.length <= 5) && this.drawEntries.length > 0) {
          this.drawEntriesOrdering = this.attemptToGuessRanking(this.drawEntries.slice());
        } else {

          setTimeout(() => {
            this.activeTab = 0;
          }, 100);
        }
      }
    },

    moveEntryOrder(index, diff) {
      if (index+diff >= 0 && index+diff < this.drawEntriesOrdering.length) {
        let temp = this.drawEntriesOrdering[index];
        this.drawEntriesOrdering[index] = this.drawEntriesOrdering[index+diff];
        this.drawEntriesOrdering[index+diff] = temp;

        this.$forceUpdate();
      }
    },


    getEntry(entry) {
      if (entry) {
        let selected = this.event.entries.filter(e => (e == entry));
        if (selected && selected.length > 0) {
          selected = selected[0];
          return (selected.name1 + (this.event.type == 'doubles' ? (', ' + selected.name2) : ''));
        }
      }

      return null;
    },

    triggerSubmit: function() {

      if (this.submitInProgress) {
        return /* don't do multiple requests */;
      }

      if (this.activeTab == 0 || this.drawEntries.length === 0) {

        if (this.drawEntries.length > 0 && this.mainDrawName && (this.consolationDrawName || this.drawEntries.length <= 5)) {
          this.activeTab = 1;
          this.drawEntriesOrdering = this.attemptToGuessRanking(this.drawEntries.slice());
        }

        return /* go to ordering tab or stop */;
      }

      let vm = this;
      let tournamentId = this.$route.params.id;
      let eventId = this.$route.params.event;

      let entries = this.drawEntriesOrdering.map(entry => entry.id);

      this.$dialog.confirm({
        message: 'Are you sure you want to regenerate all draws? THIS WILL DELETE ALL EXISTING DRAWS AND MATCHES.',
        type: 'is-danger',

        onConfirm: () => {
          vm.submitInProgress = true;
          vm.failedSubmit = false;

          axios.post('/api/tournament/' + tournamentId + '/event/' + eventId + '/generator', {
            mainDrawName: vm.mainDrawName,
            consolationDrawName: (vm.consolationDrawName || 'Group B'),

            preferDifferentTeams: vm.preferDifferentTeams,
            entries: entries
          })
                  .then(function(response){
                    vm.submitInProgress = false;
                    vm.failedSubmit = false;

                    vm.$store.dispatch('tournamentEventsChanged', { tournamentId: tournamentId, events: response.data, suggestedPage: '/tournaments/' + tournamentId + '/events/' + eventId + '/draws' });
                  })
                  .catch(function(){
                    vm.submitInProgress = false;
                    vm.failedSubmit = true;
                  });
        }
      });
    }
  },

  name: 'tournament-event-generator',
  components: { Entry },
}
</script>



<style scoped>

  div.tags {
    display: block;
    clear: both;
  }

  div.tags span.tag.is-info {
    float: left;
    clear: both;
  }
</style>